
const IndonesiaFooter = () => {
  return (
    <footer className="bg-gradient-to-r from-red-600 to-red-800 text-white py-8 mt-auto">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid md:grid-cols-3 gap-8 mb-6">
          {/* Company Info */}
          <div>
            <h4 className="font-bold text-lg mb-3">NEXX TELECOM</h4>
            <p className="text-red-100 text-sm">
              Penyedia solusi internet residensial AS terpercaya untuk pengguna Indonesia.
            </p>
            <p className="text-red-100 text-sm mt-2">
              Trusted US residential internet solutions for Indonesian users.
            </p>
          </div>

          {/* Layanan / Services */}
          <div>
            <h4 className="font-bold text-lg mb-3">Layanan • Services</h4>
            <ul className="space-y-2 text-sm text-red-100">
              <li>• Proxy Residensial • Residential Proxies</li>
              <li>• VPN Residensial • Residential VPN</li>
              <li>• Remote Desktop • Remote Desktop</li>
            </ul>
          </div>

          {/* Hubungi Kami / Contact */}
          <div>
            <h4 className="font-bold text-lg mb-3">Hubungi Kami • Contact Us</h4>
            <p className="text-red-100 text-sm mb-2">
              Dukungan 24/7 tersedia
            </p>
            <p className="text-red-100 text-sm">
              24/7 Support Available
            </p>
            <div className="mt-3">
              <a 
                href="mailto:support@nexx.net" 
                className="text-white hover:text-red-200 transition-colors text-sm font-medium"
              >
                support@nexx.net
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-red-500/30 pt-6 text-center">
          <p className="text-red-100 text-sm">
            © 2025 NEXX TELECOM LLC. Semua hak dilindungi • All rights reserved.
          </p>
          <p className="text-red-200 text-xs mt-2">
            🇮🇩 Melayani Indonesia dengan bangga • Proudly serving Indonesia
          </p>
        </div>
      </div>
    </footer>
  );
};

export default IndonesiaFooter;
